import * as React from "react";
import {isEmpty as _isEmpty} from "lodash";
import {IDiagnosis} from "@curefit/care-common";
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader";

/**
 * Created by abhinav on 28/01/18.
 */

export interface PatientDiagnosisViewProps {
    diagnosisData: IDiagnosis[];
}

let DiagnosisEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "text", display: "DIAGNOSIS"},
    {label: "specifics", display: "SPECIFICS"}
];

class PatientDiagnosisView extends React.Component<PatientDiagnosisViewProps> {

    constructor(props: PatientDiagnosisViewProps) {
        super(props);
    }

    render() {
        return (
            <div className="patient-diagnosis-view-container">
                {
                    _isEmpty(this.props.diagnosisData) && <p>No Data to show</p>
                }
                {
                    !_isEmpty(this.props.diagnosisData) &&
                    <div>
                        <CustomHeader headerInfos={DiagnosisEditorHeaderInfos} rootCls={"patient-diagnosis"}/>
                        {
                            this.props.diagnosisData.map((diagnosis: IDiagnosis, index: number) => {
                                return <div className={"patient-diagnosis-view-item"}>
                                    <div className={"patient-diagnosis-text in-blk"}>
                                        <span className={"wrap-element"}>{diagnosis.codeText}</span>
                                        <span className={"wrap-element"}>{diagnosis.diagnosis}</span>
                                        <span className={"diagnosis-type"}>{diagnosis.diagnosisType}</span>
                                    </div>
                                    <div className={"patient-diagnosis-specifics in-blk"}>
                                        <span>{diagnosis.comment}</span>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                }
            </div>
        );
    }
}

export default PatientDiagnosisView